// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"86":"c605ebc47846d005b300","672":"328d3fe36d9feb12b0ba"}[chunkId] + ".js";
};